export default class AutoSaveSelect {
  constructor() {
    this.bindSelectOnChange();
  }

  bindSelectOnChange() {
    N2.handle("change", ".autosave-select", (e) => {
      const { klass, url } = e.target.dataset;
      const { name, value } = e.target;
      const form = new N2Styles.manualForm();
      form.setRootParam(klass);
      form.form.attr("method", "patch");
      form.setUrl(url);
      form.addInput(name, value);

      form.sync({
        success: this.onComplete,
        error: this.onError,
        context: this,
      });
    });
  }

  onComplete(resp) {
    this.showToast(resp.message);
  }

  onError(resp) {
    this.showToast(resp.statusText);
  }

  showToast(msg) {
    new N2Styles.toast(msg);
  }
}
